import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles((theme) => ({
  modalContent: {
    margin: "20px 0 0 0",
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  addBookingFieldModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex",
        },
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px",
      },
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "0px 24px 24px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
  },
  btnContainer: {
    marginTop: "32px",
  },
  inputContainer: {
    display: "flex",
    marginBottom: "20px",
    flexDirection: "column",
    "& input": {
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      MozAppearance: "textfield",
      "&::-webkit-inner-spin-button": {
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "textfield",
        margin: "0",
      },
      "&::-webkit-outer-spin-button": {
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "textfield",
        margin: "0",
      },
      "&:focus": {
        outline: "none",
      },
    },
    "& .input-error": {
      border: "1px solid " + colors.mediumRed,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
      backgroundImage: `url(${checkIconRed})`,
    },
  },
  cancelBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center",
  },
  createBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  colCancel: {
    padding: "0px",
    marginRight: "6px",
  },
  colRemove: {
    padding: "0px",
  },
  btnsRow: {
    flexWrap: "nowrap",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey,
    marginBottom: "6px",
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    marginTop: "6px",
    lineHeight: "20px",
  },
  iconColor: {
    "& path": {
      stroke: theme.icon.stroke
    },
  },
  lengthCount: {
    color: colors.mediumGrey,
    fontSize: "14px",
    textAlign: "left",
    marginTop: "6px",
    lineHeight: "20px",
  },
  divider: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 1,
    margin: "20px 0px",
  },
  toggleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    "& h6": {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
      color: colors.grey,
      marginBottom: "2px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.mediumGrey,
      margin: "0px",
    },
  },
}));

export default styles;
